<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page014">
<div class="jstfy" id="page014_1">BAGUETTE</div>
<div class="jstfy" id="page014_2">TIME REQUIRED: <span class="page014_2a">1 hour</span></div>
<div class="jstfy" id="page014_3">‘B<span class="small">aguette</span>’ <span class="small">is the</span> French word for a stick, most likely a reference</div>
<div class="jstfy" id="page014_4">+ 6 hours resting time</div>
<div class="jstfy" id="page014_5">to its long and slender shape.</div>
<div class="jstfy" id="page014_6">1.</div>
<div class="jstfy" id="page014_6a"><span class="page014_6a"> Combine the dry ingredients well, add the water and mix</span></div>
<div class="jstfy" id="page014_7">Makes 6</div>
<div class="jstfy" id="page014_8">thoroughly. Use a hand mixer [fitted with a dough hook] to</div>
<div class="jstfy" id="page014_9">1 kg plain flour</div>
<div class="jstfy" id="page014_10">knead the dough until it is smooth and comes away from the side</div>
<div class="jstfy" id="page014_11">2 sachets dry yeast</div>
<div class="jstfy" id="page014_12">of the bowl. Dust the dough with a little flour, cover with a cloth</div>
<div class="jstfy" id="page014_13">750 ml lukewarm water</div>
<div class="jstfy" id="page014_14">and rest in a warm place for about 6 hours.</div>
<div class="jstfy" id="page014_15">2.</div>
<div class="jstfy" id="page014_15a"><span class="page014_15a"> On a floured pastry board, knead the dough well and divide</span></div>
<div class="jstfy" id="page014_16">3–4 tsp salt</div>
<div class="jstfy" id="page014_17">into 6 pieces. Knead each piece again and roll up into a sausage.</div>
<div class="jstfy" id="page014_18">3.</div>
<div class="jstfy" id="page014_18a"><span class="page014_18a"> Line baking trays with baking parchment and lay 3 baguettes</span></div>
<div class="jstfy" id="page014_19">on each tray with the join tucked underneath. Cover again and</div>
<div class="jstfy" id="page014_20">rest for 10 minutes. Preheat the oven to 240°C/475°F/gas 9.</div>
<div class="jstfy" id="page014_21">4.</div>
<div class="jstfy" id="page014_21a"><span class="page014_21a"> Slash each baguette several times along its length on the</span></div>
<div class="jstfy" id="page014_22">diagonal with a sharp knife and brush with water. With the</div>
<div class="jstfy" id="page014_23">oven shelf on the second position from the bottom, bake for 15</div>
<div class="jstfy" id="page014_24">minutes. Then lower the temperature to 200°C/400°F/gas 6 and</div>
<div class="jstfy" id="page014_25">bake for 30 more minutes.</div>
<div class="jstfy" id="page014_26">Tip:</div>
<div class="jstfy" id="page014_26a"><span class="page014_26a">Baguettes are traditionally only made using wheat flour,</span></div>
<div class="jstfy" id="page014_27">yeast, water and salt. For a little variety, the only additional</div>
<div class="jstfy" id="page014_28">ingredients allowed are less than two per cent broad bean flour,</div>
<div class="jstfy" id="page014_29">soya flour or malted wheat flour.</div>
<div class="jstfy" id="page014_30">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page014_0">14</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_014.vue?43ff2bbd